'use client';

import { styled } from '@linaria/react';
import { decode } from 'he';
import useTypewriter from '@fe-news/hooks/use-type-writer';
import { sanitize } from 'isomorphic-dompurify';
import { SCREEN_SIZE } from '@fe-news/styles/style';

const Container = styled.main`
  margin-top: 12px;
  text-align: left;
`;

const Cursor = styled.span`
  display: inline-block;
  width: 4px;
  height: 12px;
  background-color: #848d97;
  margin-left: 2px;
  animation: blink 0.5s step-end infinite;

  @keyframes blink {
    50% {
      opacity: 0;
    }
  }
`;

const Text = styled.p<{ isAiGc?: boolean }>`
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: 0.5px;
  color: #383838;

  @media screen and (min-width: ${SCREEN_SIZE.DESKTOP}px) {
    font-size: 15px;
    line-height: 1.53;
  }

  display: -webkit-box;
  -webkit-line-clamp: ${({ isAiGc }) => (isAiGc ? 11 : 9)};
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  @media screen and (min-width: ${SCREEN_SIZE.MOBILE}px) {
    -webkit-line-clamp: ${({ isAiGc }) => (isAiGc ? 13 : 9)};
  }
`;

type ArticleContentProps = {
  content: string;
  isAiGc: boolean;
};

const ArticleContent = ({ content, isAiGc }: ArticleContentProps) => {
  const sanitizedHtml = sanitize(content);
  const decodedHtml = decode(sanitizedHtml ?? '');

  const { displayText } = useTypewriter({
    content: decodedHtml
  });

  return (
    <Container>
      <Text isAiGc={isAiGc}>
        {displayText}
        <Cursor />
      </Text>
    </Container>
  );
};

export default ArticleContent;
